const PaymentInfo = (props: any) => {
    const {remittanceDetail} = props
     return (
        <>
            <div className="payment-info paymentText">
              <span className="payment-heading-text">Payment Information</span>
              <ul>
                <li>
                  <label htmlFor="">Batch No.</label>
                  <span>{remittanceDetail?.payment?.batch_no}</span>
                </li>
                  <li>
                  <label htmlFor="">TC ID</label>
                  <span>{remittanceDetail?.payment?.tc_id}</span>
                </li>
                  <li>
                  <label htmlFor="">Payment Proof</label>
                  <span className="link-txt"><a href={remittanceDetail?.payment?.payment_proof} target="blank">View</a></span>
                </li>
                  <li>
                  <label htmlFor="">Comment</label>
                  <span>{remittanceDetail?.payment?.remarks}</span>
                </li>
              </ul>
          </div>
        </>
     )
}
export default PaymentInfo;